<template>
  <div>
    <div id="mapContainer"></div>
  </div>
</template>

<script>
import "leaflet/dist/leaflet.css";
import "leaflet-gpx/gpx.js";
import "leaflet/dist/images/marker-shadow.png";
import L from "leaflet";
import * as turf from "@turf/turf";
export default {
  components: {},
  props: ["list_sos", "center_on"],
  data() {
    return {
      map: {},
      list_marker_points: [],
      marker_coureur: {},
      focus_marker: {},
      line: [],
      icons: [],
      fond_carte: {},
    };
  },

  watch: {
    center_on: function () {
      if (this.center_on != null) {
        this.map.panTo(new L.LatLng(this.center_on.lat, this.center_on.lng));
      }
    },
    "$store.state.map_settings.selected_mode": function () {
      this.fond_carte.setUrl(this.$store.state.map_settings.mode[this.$store.state.map_settings.selected_mode].link);
    },
    list_sos: function (newVal, oldVal) {
      this.displayPoints();
    },
  },

  methods: {
    displayPoints: function () {
      for (var i = 0; i < this.list_marker_points.length; i++) {
        this.map.removeLayer(this.list_marker_points[i]);
      }
      this.list_marker_points = [];
      var options = {
        units: "kilometers",
      };
      for (var i = 0; i < this.list_sos.length; i++) {
        var sos = this.list_sos[i];

        let current_icon = new L.DivIcon({
          className: "coureur-icon",
          html:
            "<div class='pin_runner_profil_container_map'><img class='pin_runner_profil_map' src='https://sportips.fr/live/includes/img/pin-runner-2.png'/><span class='pin_runner_content_map'>" +
            sos.nom.charAt(0).toUpperCase() +
            sos.prenom.charAt(0).toUpperCase() +
            "</span></div>",
          iconAnchor: [17, 40],
        });
        var marker = new L.marker([sos.lat, sos.lng], {
          title: sos.doss,
          icon: current_icon,
        });
        this.list_marker_points.push(marker);
        marker.addTo(this.map);

        this.map.panTo(new L.LatLng(sos.lat, sos.lng));
      }
    },

    initMap() {
      var _this = this;
      this.map = L.map("mapContainer", {
        zoomControl: false,
        dragging: !L.Browser.mobile,
        tap: !L.Browser.mobile,
      });
      this.map.setView([43.4258061, 6.72568988], 13);
      this.fond_carte = L.tileLayer(this.$store.state.map_settings.mode[this.$store.state.map_settings.selected_mode].link, {
        zoomControl: false,
        maxZoom: 17,
        attribution:
          'Map data: &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, <a href="http://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)',
      }).addTo(this.map);
    },
  },
  mounted() {
    this.initMap();
    this.displayPoints();
  },
};
</script>

<style>
.pin_runner_profil_map {
  position: absolute;

  width: 30px;
}
.pin_runner_profil_container_map {
  font-weight: bold;
  padding: 0 2px;
  width: 50px;
}

.pin_runner_content_map {
  position: absolute;

  top: 9px;
  left: 9px;
  color: white;
}
</style>
